<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      align-center
      justify-center
      wrap>
      <v-flex
        md8
        xs8
        lg8
        text-xs-center>
        <material-card
          v-if="languageReady"
          :text="`${ $t('Web configuration') }`"
          title="MAGLINK LX"
          color="dover-blue">
          <v-form @submit.prevent="login">
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  md12
                  xs12
                  lg12>
                  <img
                    :src="getImageUrl()"
                    width="85%">
                </v-flex>
                <v-flex
                  md12
                  xs12
                  lg12>
                  <span
                    class="caption grey--text font-weight-bold">
                    {{ $t('Language selection') }}
                  </span>
                  <hr>
                  <v-radio-group
                    v-model="currentLanguage"
                    :row="true"
                    @change="onLanguageChange">
                    <v-radio
                      v-for="(element, index) in languages"
                      :key="index"
                      :visible="element.enabled"
                      :label="element.language"
                      :value="element.code" />
                  </v-radio-group>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12
                  text-xs-center>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="dover-blue"
                    type="submit">
                    {{ $t('Enter').toUpperCase() }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { loadLanguageAsync, loadingCompleted } from '@/i18n'

export default {
  data: () => ({
    languages: [],
    currentLanguage: ''
  }),
  computed: {
    languageReady () {
      return loadingCompleted
    }
  },
  mounted () {
    if (localStorage.currentLanguage) {
      this.currentLanguage = localStorage.currentLanguage
    } else {
      this.currentLanguage = this.$i18n.locale
    }

    this.Maglink.GetLanguages()
      .then(resp => {
        // this.languages = resp.data
        resp.data.forEach(item => {
          if (item.enabled) {
            item.language = this.$t(item.language)
            this.languages.push(item)
          }
        })
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onLanguageChange () {
      localStorage.currentLanguage = this.currentLanguage
      loadLanguageAsync(this.currentLanguage, this)
    },
    snack (color, message) {
      message = this.$t('Landing page') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    },
    getImageUrl () {
      return './img/small-station.jpg'
      // return './img/animated-tank.gif'
    },
    login () {
      this.$router.push('/login')
    }
  }
}
</script>
